import {
  AfterViewInit,
  Component,
  ElementRef,

  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { isNil, isNull } from 'lodash-es';


export interface AgGridNumberEditorParams {
  defaultValue?: number;
  allowDecimals?: boolean;
  /**
   * Depending on the context, we might want to use a different value when the user enters an empty string
   */
  emptyValueToUseCallback: () => undefined | null | number;
}

interface AgGridNumberEditorInternalParams extends AgGridNumberEditorParams {
  value: string;
}

@Component({
  selector: 'ag-grid-number-editor',
  templateUrl: './ag-grid-number-editor.component.html',
  styleUrls: ['./ag-grid-number-editor.component.css'],
})
export class AgGridNumberEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: AgGridNumberEditorInternalParams;

  public value: string;

  @ViewChild('input')
  public nativeInput: ElementRef<HTMLInputElement>;

  public get allowDecimals(): boolean {
    return this.params.allowDecimals ?? false;
  }

  ngAfterViewInit() {
    // focus on the input
    setTimeout(() => {
      this.nativeInput.nativeElement.focus();

      this.nativeInput.nativeElement.setSelectionRange(0, this.nativeInput.nativeElement.value.length);
    });
  }

  agInit(params: any): void {
    this.params = params;

    const value = parseInt(this.params.value);

    if (isFinite(value)) {
      this.value = value.toString();
    } else {
      console.log('[AgGridNumberEditorComponent:agInit] value not finite');
      this.value = '';
    }
  }

  /* Component Editor Lifecycle methods */
  // the final value to send to the grid, on completion of editing
  getValue(): number|undefined|null {
    const emptyValue = this.params.emptyValueToUseCallback();
    // If user hasnt entered anything, we will return undefined
    if(this.value === '') {
      return emptyValue
    }
    // If we have a default value, and this is nil, we will use the default value
    if ( isNil(this.value) && !isNil(this.params.defaultValue ) ) {
      return this.params.defaultValue;
    }


    return parseFloat(this.value);
  }

  // Gets called once before editing starts, to give editor a chance to
  // cancel the editing before it even starts.
  isCancelBeforeStart() {
    return false;
  }

  // Gets called once when editing is finished (eg if Enter is pressed).
  // If you return true, then the result of the edit will be ignored.
  isCancelAfterEnd() {
    return false;
  }
}
